import Layout from './components/Layout';
import Dashboard from './pages/Dashboard';
import Warning from './pages/WarningList';
import Home from './pages/Home';
import About from './pages/About';
import Device from './pages/Device';
import LoginPage from './pages/LoginPage';
import Account from './pages/Account';
import FirstLoginReset from './pages/FirstLoginReset';
import MonthlyReport from './pages/MonthlyReport';
import AdminPanel from './pages/AdminPanel';

export const routes = [
    { path: '/login', element: <LoginPage />, public: true },
    { path: '/first-login/reset', element: <FirstLoginReset />, public: true },
    {
        path: '/',
        element: <Layout />,
        children: [
            { index: true, element: <Dashboard />, protected: true },
            { path: 'warning', element: <Warning />, protected: true },
            { path: 'home', element: <Home />, protected: true },
            { path: 'about', element: <About />, protected: true },
            { path: 'device/:deviceName', element: <Device />, protected: true },
            { path: 'account', element: <Account />, protected: true },
            { path: 'monthly-report', element: <MonthlyReport />, protected: true },
            { path: 'admin', element: <AdminPanel />, protected: true },
        ],
    },
];
